export default __webpack_public_path__ + "static/media/vipo-logo.46e469b3.png";